import axios from './axios-instance';

export function fetchList(data) {
  return axios.get('/unioncenter/management/store/list', {
    params: {
      ...data,
    },
  });
}

export function fetchListByYunCha(payload) {
  return axios.post('/unioncenter/store/yuncha-list', payload);
}
// 查询省市列表
export function getSelectListProvince() {
  return axios.get('/unioncenter/common/province/list', {});
}
// 查询业态列表
export function getSelectListFormat() {
  return axios.get('/unioncenter/common/format/list', {});
}
// 查询门店列表-所有（modal筛选）
export function getStoreAllForChose(payload) {
  return axios.post('/unioncenter/common/store/list', payload);
}
// 查询门店列表-分页
export function getStoreManage(payload) {
  return axios.get('/unioncenter/store/store-page', { params: payload });
}
// 分组列表
export function getStoreGroup(payload) {
  return axios.get('/unioncenter/store-group/page', { params: payload });
}
// 分组删除
export function deleteStoreGroup(payload) {
  return axios.get('/unioncenter/store-group/del', { params: payload });
}
// 新建 分组
export function addStoreGroup(payload) {
  return axios.post('/unioncenter/store-group/add', payload);
}
// 更新 分组
export function editStoreGroup(payload) {
  return axios.post('/unioncenter/store-group/edit', payload);
}
